
import React, { Component, PureComponent } from 'react'
import ReactDOM from 'react-dom'
import StepHeadline from '../Titles/StepHeadline'
import CarTabs from './CarTabs'
import SerieTab from './Tabs/SerieTab'
import MatriculTab from './Tabs/MatriculTab'
import ModelTab from './Tabs/ModelTab'
import CarDetailsLoader from './CarDetailsLoader'
import LayoutTabs from '../../layouts/LayoutTabs'
import CONSTANTS from '../../constants'
import { slugify, formattedAdress } from '../../helpers/functions'
import LayoutStandardWidth from '../../layouts/LayoutStandardWidth'
import { headTitleTag } from '../../helpers/functions'
import { pushToGTMTracker } from '../../helpers/trackerManager'
import { connect } from 'react-redux'
import {
  setVeiculeInfos,
  setVeiculeKilo,
  selectedServices,
  CurrentStepSetAction
} from '../../actions/action'
import './CarDetails.css'
import { withRouter } from "react-router";
import MatriculeTabFlex from './Tabs/MatriculeTabFlex'
import SerieTabFlex from './Tabs/SerieTabFlex'
import ModelTabFlex from './Tabs/ModelTabFlex'
const mapStateToProps = state => state
const mapDispatchToProps = { setVeiculeInfos, setVeiculeKilo, CurrentStepSetAction, selectedServices }

class CarDetails extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      modelPrevData: {
        EnergyInput: (Object.values(props.store.car).length
          ? props.store.car.MotorCode : '0'),
        ModelInput: (Object.values(props.store.car).length
          ? props.store.car.ModelCode : '0')
      },
      seriePrevData: {
        serieInput: props.store.car.SerialNumber || ''
      },
      immaPrevData: {
        immaInput: props.store.car.Registration
      },
      pageLoaded: false,
      oldSerialNumber: props.store.car.SerialNumber || '',
      oldImmaInput: props.store.car.Registration || '',
      oldEnergyInput: props.store.car.MotorCode || '',
      oldModelInput: props.store.car.ModelCode || ''
    }
    this.updateServicesAfterDataChanged = this.updateServicesAfterDataChanged.bind(this)
  }

  componentDidMount() {
    // scroll to the top on user arrive to page
    window.scrollTo(0, 0)
    if (this.props.store.dealer.city) {
      this.setState({
        selectedAdress: {
          adress: this.props.store.dealer.city.replace(/-/g, ' ')
        }
      })
    }


    // initialase the car in case the user decide to change the car.
    this.props.CurrentStepSetAction(3)
    console.log('Change step to 3 in CarDetails')
    window.setTimeout(function () {
      this.setState({ pageLoaded: true })
    }.bind(this), 3000)

    pushToGTMTracker('car-details-page', window.siteConfig.v2vehicule.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()))
  }

  updateServicesAfterDataChanged() {
    if (
      (this.state.immaPrevData.immaInput !== this.state.oldImmaInput) ||
      (this.state.seriePrevData.serieInput !== this.state.oldSerialNumber) ||
      (this.state.modelPrevData.EnergyInput !== this.state.oldEnergyInput) ||
      (this.state.modelPrevData.ModelInput !== this.state.oldModelInput)

    ) {
      console.log(this.props.store.SelectedServices)
      const SelectedServices = Object.assign({}, this.props.store.SelectedServices)
      const dataUpdatedWithSelectedForfaits = Object.values(SelectedServices).map(function (forfaitFamily, key) {
        forfaitFamily.forfaits = []
        console.log(forfaitFamily)
        return forfaitFamily
      })

      console.log(dataUpdatedWithSelectedForfaits)
      this.props.selectedServices(dataUpdatedWithSelectedForfaits)

    }
  }

  render() {


    const SEO_TITLE = (window.siteConfig.v2vehicule != undefined ? window.siteConfig.v2vehicule.Title : '')
    const SEO_DESC = (window.siteConfig.v2vehicule != undefined ? window.siteConfig.v2vehicule.MetaDescription : '')

    const ActivateTabImmat = (!!Number(window.siteConfig.ActivateTabImmat))
    const ActivateTabNumSerie = (!!Number(window.siteConfig.ActivateTabNumSerie))
    const ActivateTabModele = (!!Number(window.siteConfig.ActivateTabModele))
    return (
      <React.Fragment>
        {
          headTitleTag(SEO_TITLE.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()),
            SEO_DESC.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()))
        }
        <StepHeadline
          Title={CONSTANTS.LABELS.vehicule_title}
          SubTitle={CONSTANTS.LABELS.vehicule_subtitle}
        />
        {this.state.pageLoaded && <CarTabs>

          {ActivateTabImmat && CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && 
            <div label={CONSTANTS.LABELS.vehicule_plate_title} order='1'>
            <LayoutTabs>
              <MatriculTab
                dataFromChild={(e) => this.setState({ immaPrevData: e })}
                prevData={this.state.immaPrevData}
                updateServicesAfterDataChanged={(e) => this.updateServicesAfterDataChanged()}
              />
            </LayoutTabs>
          </div>}

          {ActivateTabImmat && CONSTANTS.SITE_INFO.BRAND_CODE === "C" && 
            <div label={CONSTANTS.LABELS.vehicule_plate_title} order='1'>
              <MatriculeTabFlex 
                dataFromChild={(e) => this.setState({ immaPrevData: e })}
                prevData={this.state.immaPrevData}
                updateServicesAfterDataChanged={(e) => this.updateServicesAfterDataChanged()} />
            </div> }

          {ActivateTabNumSerie && CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && <div label={CONSTANTS.LABELS.vehicule_serial_title} order='2'>
            <LayoutTabs>
              <SerieTab
                dataFromChild={(e) => this.setState({ seriePrevData: e })}
                prevData={this.state.seriePrevData}
                updateServicesAfterDataChanged={(e) => this.updateServicesAfterDataChanged()}
              />
            </LayoutTabs>
          </div>}

          {ActivateTabNumSerie && CONSTANTS.SITE_INFO.BRAND_CODE === "C" &&
            <div label={CONSTANTS.LABELS.vehicule_serial_title} order='2'>
              <SerieTabFlex
                dataFromChild={(e) => this.setState({ seriePrevData: e })}
                prevData={this.state.seriePrevData}
                updateServicesAfterDataChanged={(e) => this.updateServicesAfterDataChanged()}
               />
            </div>
          }

          {ActivateTabModele && CONSTANTS.SITE_INFO.BRAND_CODE !== "C" &&
            <div label={CONSTANTS.LABELS.vehicule_model_title} order='3'>
            <LayoutTabs>
              <ModelTab
                dataFromChild={(e) => this.setState({ modelPrevData: e })}
                prevData={this.state.modelPrevData}
                updateServicesAfterDataChanged={(e) => this.updateServicesAfterDataChanged()}
              />
            </LayoutTabs>
          </div>}

          {ActivateTabModele && CONSTANTS.SITE_INFO.BRAND_CODE === "C" && 
            <div label={CONSTANTS.LABELS.vehicule_model_title} order='3'>
              <ModelTabFlex
                dataFromChild={(e) => this.setState({ modelPrevData: e })}
                prevData={this.state.modelPrevData}
                updateServicesAfterDataChanged={(e) => this.updateServicesAfterDataChanged()}
              />
            </div>}

        </CarTabs>}
        {!this.state.pageLoaded && <LayoutStandardWidth><CarDetailsLoader /></LayoutStandardWidth>}
      </React.Fragment>
    )
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CarDetails)); 
